import { useTranslation } from "react-i18next";

import { useClubSettings } from "../../../providers";
import { SettingsContainer } from "../../Settings/SettingsContainer";
import { KisiIntegrationCard } from "./KisiIntegration/KisiIntegrationCard";
import { KisiIntegrationCardOld } from "./KisiIntegration/old/KisiIntegrationCardOld";
import { XeroIntegrationCard } from "./XeroIntegration/XeroIntegrationCard";
import { ZapierIntegrationCard } from "./ZapierIntegration/ZapierIntegrationCard";

export function Integrations() {
  const { t } = useTranslation();
  const { featureFlags } = useClubSettings();

  return (
    <SettingsContainer
      title={t("pages.integrations.title")}
      subTitle={t("pages.integrations.subTitle")}
    >
      <div className="flex flex-row flex-wrap gap-4 overflow-y-scroll pb-36">
        {featureFlags.PORTAL_KISI_INTEGRATION ? (
          <KisiIntegrationCard />
        ) : (
          <KisiIntegrationCardOld />
        )}
        {featureFlags.PORTAL_XERO && <XeroIntegrationCard />}
        <ZapierIntegrationCard />
      </div>
    </SettingsContainer>
  );
}
